import { FormControlLabel, Grid, Switch } from "@mui/material"
import { Controller, useFormContext } from "react-hook-form"
import { NodeFormValues } from "@features/builder/NodeDrawer/NodeForm/index"

export default function NodeExportableField() {
  const form = useFormContext<NodeFormValues>()

  const handleToggle = (value: boolean) => {
    if (form.formState.disabled) return
    form.setValue("exportExcluded", value, {
      shouldDirty: true,
    })
  }

  return (
    <Grid container direction="row" justifyContent="space-between">
      <Grid item>
        <Controller
          control={form.control}
          name="exportExcluded"
          render={({ field }) => (
            <FormControlLabel
              label="Exclude from parameters export and results download"
              sx={{ ml: 0 }}
              control={
                <Switch
                  {...field}
                  checked={field.value ?? false}
                  onChange={(event) => handleToggle(event.target.checked)}
                />
              }
            />
          )}
        />
      </Grid>
    </Grid>
  )
}
